<p-toast position="top-right"></p-toast>
<p-confirmdialog [style]="{ width: '420px' }"></p-confirmdialog>

<!-- "Why was this deal lost?" — shown when a terminal non-won status is picked. -->
<app-loss-reason-dialog [(visible)]="showLossDialog" [statusName]="lossDialogStatusName"
                        (confirmed)="onLossReasonConfirmed($event)"></app-loss-reason-dialog>

<!-- Intervention Dialog -->
<p-dialog
  [(visible)]="showInterveneDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '440px' }"
  header="Manual Intervention">

  <div class="intervene-dialog-body">
    <div class="intervene-info">
      <i class="pi pi-exclamation-triangle intervene-icon"></i>
      <p>Triggering a manual intervention will flag this status for human review. Please provide a reason below.</p>
    </div>
    <div class="reopen-section">
      <div class="reopen-section__label">Reason <span class="reopen-required">*</span></div>
      <textarea
        pTextarea
        [(ngModel)]="interveneReason"
        rows="3"
        placeholder="e.g. Manual intervention required due to SLA breach…"
        class="reopen-reason-input">
      </textarea>
    </div>
  </div>

  <ng-template #footer>
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="showInterveneDialog = false; interveneReason = ''" />
    <p-button
      label="Confirm Intervention"
      icon="pi pi-exclamation-triangle"
      severity="danger"
      [loading]="intervening"
      [disabled]="!interveneReason.trim()"
      (onClick)="submitIntervene()">
    </p-button>
  </ng-template>
</p-dialog>

<!-- Reopen Status Dialog -->
<p-dialog
  [(visible)]="showReopenDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '480px' }"
  header="Reopen Status">

  <div class="reopen-dialog-body">

    <!-- Task selection -->
    <div class="reopen-section">
      <div class="reopen-section__label">Select tasks to reopen</div>
      <div class="reopen-task-list">
        <div *ngFor="let task of statusTasks" class="reopen-task-item"
          [class.is-selected]="isReopenTaskSelected(task.taskId)"
          (click)="toggleReopenTask(task.taskId)">
          <span class="reopen-task-check">
            <i class="pi" [class.pi-check-square]="isReopenTaskSelected(task.taskId)" [class.pi-stop]="!isReopenTaskSelected(task.taskId)"></i>
          </span>
          <span class="reopen-task-name">{{ task.name || task.taskName }}</span>
          <span class="reopen-task-state" [ngClass]="'reopen-state-' + (task.state || '').toLowerCase()">{{ task.state }}</span>
        </div>
        <div *ngIf="!statusTasks.length" class="reopen-empty">No tasks available</div>
      </div>
    </div>

    <!-- Reason -->
    <div class="reopen-section">
      <div class="reopen-section__label">Reason for reopening <span class="reopen-required">*</span></div>
      <textarea
        pTextarea
        [(ngModel)]="reopenReason"
        rows="3"
        placeholder="Describe why this status is being reopened…"
        class="reopen-reason-input">
      </textarea>
    </div>

  </div>

  <ng-template #footer>
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="showReopenDialog = false" />
    <p-button
      label="Reopen"
      icon="pi pi-replay"
      severity="warn"
      [loading]="reopeningStatus"
      [disabled]="!reopenReason.trim() || !reopenSelectedTaskIds.length"
      (onClick)="submitReopen()">
    </p-button>
  </ng-template>
</p-dialog>

<!-- Vendors dialog -->
<p-dialog
  [(visible)]="showVendorsDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '85vw', maxWidth: '1100px' }"
  [contentStyle]="{ maxHeight: '70vh', overflow: 'auto' }"
  [header]="'Vendors for Lead #' + (selectedLead?.id || '-')"
>
  <p-table [value]="vendorReplies" [loading]="loadingVendors" responsiveLayout="scroll" styleClass="p-datatable-sm">
    <ng-template #header>
      <tr>
        <th>Reply ID</th><th>Vendor ID</th><th>Status</th>
        <th>Reply Payload</th><th>Responded At</th><th>Actions</th>
      </tr>
    </ng-template>
    <ng-template #body let-reply>
      <tr>
        <td>{{ reply.id }}</td>
        <td>{{ reply.vendorId }}</td>
        <td>{{ reply.status || '-' }}</td>
        <td class="reply-payload">{{ reply.replyPayload || '-' }}</td>
        <td>{{ reply.respondedAt ? (reply.respondedAt | appDate:'datetime') : '-' }}</td>
        <td>
          <div class="flex gap-2 flex-wrap">
            <p-button label="Assign Vendor" size="small" [outlined]="true" [loading]="leadActionLoading" (onClick)="assignVendor(selectedLead!.id, reply.vendorId)" />
            <p-button label="Select Vendor" size="small" severity="success" [loading]="leadActionLoading" (onClick)="selectVendor(selectedLead!.id, reply.vendorId)" />
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr><td colspan="6">No vendor replies found.</td></tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- ═══════════════════════════════════════════════════════════════
     PAGE SHELL
════════════════════════════════════════════════════════════════ -->
<div class="conv-page">

  <!-- Top bar -->
  <div class="conv-topbar">
    <div class="conv-topbar__title">
      <i class="pi pi-comments"></i>
      <div>
        <h1>Live Conversations</h1>
        <p>Monitor active customer conversations in real time.</p>
      </div>
    </div>
    <!-- Workflow action buttons (Reset / Hand Over / End Session) removed — this screen is a focused inbox. -->
    <!-- Managers/admins only: an agent's inbox is server-scoped to chats whose case is assigned
         to them, so a chat they started with an unrelated customer would vanish on the next load. -->
    <button *ngIf="isManagerView" pButton type="button" icon="pi pi-plus" label="New conversation"
            (click)="openNewChatDialog()" style="margin-left:auto;"></button>
  </div>

  <!-- New conversation: search a customer (name / email / mobile) and open their chat.
       Sending follows the normal 24h rule — closed window offers an approved template. -->
  <p-dialog header="New conversation" [(visible)]="showNewChatDialog" [modal]="true"
            [style]="{width: '440px'}" [dismissableMask]="true">
    <p-iconfield iconPosition="left" styleClass="w-full" style="display:block;margin-bottom:8px;">
      <p-inputicon class="pi pi-search"></p-inputicon>
      <input pInputText type="text" class="w-full" placeholder="Search by name, email or mobile…"
             [(ngModel)]="newChatQuery" (ngModelChange)="onNewChatQueryChange()" autofocus />
    </p-iconfield>
    <div *ngIf="newChatSearching" style="text-align:center;padding:14px;color:var(--text-color-secondary);">
      <i class="pi pi-spin pi-spinner"></i>
    </div>
    <div *ngIf="!newChatSearching && newChatQuery.trim().length >= 2 && !newChatResults.length"
         style="text-align:center;padding:14px;color:var(--text-color-secondary);font-size:13px;">
      No customer found for “{{ newChatQuery }}”.
    </div>
    <div style="max-height:320px;overflow-y:auto;">
      <div *ngFor="let r of newChatResults" (click)="startChatWith(r)"
           style="display:flex;align-items:center;gap:10px;padding:9px 6px;border-bottom:1px solid var(--surface-border);cursor:pointer;"
           [style.opacity]="startingChat ? .6 : 1">
        <div style="width:34px;height:34px;border-radius:50%;background:var(--surface-200);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex:none;">
          {{ (r.name || r.waId || '?').slice(0, 2).toUpperCase() }}
        </div>
        <div style="min-width:0;flex:1;">
          <div style="font-weight:600;font-size:13.5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ r.name || r.phone }}</div>
          <div style="font-size:12px;color:var(--text-color-secondary);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
            {{ r.phone }}<span *ngIf="r.email"> · {{ r.email }}</span>
          </div>
        </div>
        <i class="pi pi-comments" style="color:var(--primary-color);flex:none;"></i>
      </div>
    </div>
    <div *ngIf="newChatQuery.trim().length < 2"
         style="padding:10px 4px;color:var(--text-color-secondary);font-size:12.5px;">
      Type at least 2 characters. Picking a customer opens their chat — if they haven't messaged in
      the last 24 hours, you'll be asked to send an approved template.
    </div>
  </p-dialog>

  <!-- Three columns -->
  <div class="conv-body" #convBody [class.is-dragging]="dragging">

    <!-- ── COL 1: Conversation list ────────────────────────────── -->
    <aside class="conv-sidebar" *ngIf="!hideSidebar" [style.width.px]="sidebarWidth" [style.min-width.px]="sidebarWidth">
      <div class="conv-sidebar__search">
        <p-iconfield iconPosition="left" styleClass="w-full">
          <p-inputicon class="pi pi-search"></p-inputicon>
          <input pInputText type="text" placeholder="Search name, number, email…" [(ngModel)]="searchTerm"
                 (ngModelChange)="onSearchTermChange()" class="w-full" />
        </p-iconfield>
        <button class="refresh-btn" (click)="loadConversations()" [disabled]="loading" title="Refresh">
          <i class="pi pi-sync" [class.spin]="loading"></i>
        </button>
      </div>

      <!-- Channel filter — WhatsApp / Web widget / both (server-side, so paging stays clean). -->
      <div class="conv-sidebar__chanfilter" style="display:flex;gap:6px;padding:2px 10px 8px;">
        <button type="button" (click)="setChannelFilter('ALL')"
          [style.background]="channelFilter === 'ALL' ? 'var(--primary-color)' : 'transparent'"
          [style.color]="channelFilter === 'ALL' ? 'var(--primary-color-text)' : 'var(--text-color)'"
          style="flex:1;border:1px solid var(--surface-border);border-radius:999px;padding:5px 6px;font-size:12px;cursor:pointer;">All</button>
        <button type="button" (click)="setChannelFilter('WHATSAPP')"
          [style.background]="channelFilter === 'WHATSAPP' ? 'var(--primary-color)' : 'transparent'"
          [style.color]="channelFilter === 'WHATSAPP' ? 'var(--primary-color-text)' : 'var(--text-color)'"
          style="flex:1;border:1px solid var(--surface-border);border-radius:999px;padding:5px 6px;font-size:12px;cursor:pointer;"><i class="pi pi-whatsapp"></i> WhatsApp</button>
        <button type="button" (click)="setChannelFilter('WEB_WIDGET')"
          [style.background]="channelFilter === 'WEB_WIDGET' ? 'var(--primary-color)' : 'transparent'"
          [style.color]="channelFilter === 'WEB_WIDGET' ? 'var(--primary-color-text)' : 'var(--text-color)'"
          style="flex:1;border:1px solid var(--surface-border);border-radius:999px;padding:5px 6px;font-size:12px;cursor:pointer;"><i class="pi pi-globe"></i> Widget</button>
      </div>

      <!-- One row instead of four. The dropdowns below are revealed on demand, and the count on
           this button is what keeps an applied filter visible once they are closed again. -->
      <div style="display:flex;gap:6px;align-items:center;padding:0 10px 8px;">
        <button type="button" (click)="filtersOpen = !filtersOpen"
          [style.background]="activeFilterCount ? 'var(--primary-color)' : 'transparent'"
          [style.color]="activeFilterCount ? 'var(--primary-color-text)' : 'var(--text-color)'"
          style="flex:1;display:flex;align-items:center;justify-content:center;gap:6px;border:1px solid var(--surface-border);border-radius:999px;padding:5px 10px;font-size:12px;cursor:pointer;">
          <i class="pi pi-filter" style="font-size:11px;"></i>
          <span>Filters<span *ngIf="activeFilterCount"> ({{ activeFilterCount }})</span></span>
          <i class="pi" [ngClass]="filtersOpen ? 'pi-chevron-up' : 'pi-chevron-down'" style="font-size:10px;"></i>
        </button>
        <button type="button" (click)="unreadOnlyFilter = !unreadOnlyFilter; onInboxFilterChange()"
          [style.background]="unreadOnlyFilter ? 'var(--primary-color)' : 'transparent'"
          [style.color]="unreadOnlyFilter ? 'var(--primary-color-text)' : 'var(--text-color)'"
          style="border:1px solid var(--surface-border);border-radius:999px;padding:5px 12px;font-size:12px;cursor:pointer;white-space:nowrap;"
          title="Show only conversations with unread messages">Unread</button>
        <a *ngIf="hasInboxFilters" (click)="clearInboxFilters()"
           style="font-size:11px;color:var(--primary-color);cursor:pointer;white-space:nowrap;">Clear</a>
      </div>

      <!-- Inbox filters — campaign / journey / agent / with-team-vs-chat. All applied SERVER-side
           so they filter every conversation, not just the loaded page. -->
      <div class="conv-sidebar__filters" *ngIf="filtersOpen"
           style="display:flex;flex-direction:column;gap:6px;padding:0 10px 8px;">
        <p-multiSelect *ngIf="campaignOptions.length" [options]="campaignOptions" [(ngModel)]="campaignFilter"
                  (onChange)="onInboxFilterChange()" optionLabel="label" optionValue="value"
                  (onClear)="campaignFilter = []; onInboxFilterChange()"
                  placeholder="Filter by campaign" [showClear]="true" [filter]="true"
                  filterPlaceHolder="Search campaigns" [showToggleAll]="true" display="comma"
                  selectedItemsLabel="{0} campaigns" [maxSelectedLabels]="1"
                  appendTo="body" styleClass="w-full" size="small"></p-multiSelect>
        <!-- Journey filter. Shown to everyone: an agent's own chats still span journeys, so
             unlike the agent filter this one is not a no-op for them. -->
        <p-multiSelect *ngIf="journeyOptions.length" [options]="journeyOptions"
                  [(ngModel)]="journeyFilter" (onChange)="onInboxFilterChange()"
                  (onClear)="journeyFilter = []; onInboxFilterChange()"
                  optionLabel="label" optionValue="value" placeholder="Filter by journey"
                  [showClear]="true" [filter]="true" filterPlaceHolder="Search journeys"
                  [showToggleAll]="true" display="comma" selectedItemsLabel="{0} journeys"
                  [maxSelectedLabels]="1"
                  appendTo="body" styleClass="w-full" size="small"></p-multiSelect>
        <!-- Agent filter - managers/admins only. Hidden for plain agents, whose inbox is
             already scoped to their own chats server-side, so it would do nothing. -->
        <p-multiSelect *ngIf="isManagerView && agentOptions.length" [options]="agentOptions"
                  [(ngModel)]="agentFilter" (onChange)="onInboxFilterChange()"
                  (onClear)="agentFilter = []; onInboxFilterChange()"
                  optionLabel="label" optionValue="value" placeholder="Filter by agent"
                  [showClear]="true" [filter]="true" filterPlaceHolder="Search agents"
                  [showToggleAll]="true" display="comma" selectedItemsLabel="{0} agents"
                  [maxSelectedLabels]="1"
                  appendTo="body" styleClass="w-full" size="small"></p-multiSelect>
        <!-- Empty = every conversation, which is why the placeholder still reads that way.
             Unread and Clear moved up to the toggle row - they are one tap, not a dropdown. -->
        <p-multiSelect [options]="statusOptions" [(ngModel)]="statusFilter" (onChange)="onInboxFilterChange()"
                  optionLabel="label" optionValue="value" appendTo="body" size="small"
                  placeholder="All conversations" [showToggleAll]="false" display="comma"
                  selectedItemsLabel="{0} selected" [maxSelectedLabels]="1"
                  styleClass="w-full"></p-multiSelect>
      </div>

      <div class="conv-sidebar__list" (scroll)="onSidebarScroll($event)">
        <!-- Loading skeleton -->
        <ng-container *ngIf="loading">
          <div class="conv-card conv-card--skeleton" *ngFor="let i of [1,2,3,4,5]">
            <div class="skel skel-avatar"></div>
            <div class="skel-lines">
              <div class="skel skel-line skel-line--lg"></div>
              <div class="skel skel-line skel-line--sm"></div>
            </div>
          </div>
        </ng-container>

        <!-- Empty state -->
        <div class="conv-sidebar__empty" *ngIf="!loading && filteredConversations.length === 0">
          <i class="pi pi-inbox"></i>
          <span>No conversations found</span>
        </div>

        <!-- Conversation card, at most three lines: title + time + TEAM/unread on one row, the
             number (omitted for a widget visitor who has not given one), then the manager-only
             case chips. No message preview - note the server still RETURNS lastMessageText,
             because the mobile chat list renders it; it is only unused here. -->
        <div
          *ngFor="let conv of filteredConversations"
          class="conv-card"
          [class.conv-card--active]="selected?.waId === conv.waId"
          (click)="selectConversation(conv)"
          role="button"
          tabindex="0"
          (keydown.enter)="selectConversation(conv)">
          <div class="conv-card__avatar">{{ convInitials(conv) }}</div>
          <div class="conv-card__body" style="min-width:0;flex:1;">
            <div style="display:flex;align-items:center;gap:6px;">
              <span class="conv-card__id" style="font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;flex:1;">
                <i class="pi" [ngClass]="channelIcon(conv.channel)" style="font-size:11px;opacity:.65;margin-right:4px;"></i>{{ convTitle(conv) }}
              </span>
              <span *ngIf="conv.lastMessageAt" style="font-size:10.5px;color:var(--text-color-secondary);flex:none;">{{ convTime(conv.lastMessageAt) }}</span>
              <!-- TEAM / unread ride the title row. They used to own a row of their own, which -
                   once the message preview was removed - was a full line of blank space with two
                   small pills pushed to its right edge. -->
              <span *ngIf="conv.handoff === 'ACTIVE'" title="Escalated — with the team"
                    style="flex:none;font-size:9.5px;font-weight:700;color:#b45309;background:#fef3c7;border-radius:999px;padding:1px 6px;">TEAM</span>
              <span *ngIf="conv.unreadCount" class="conv-card__unread"
                    style="flex:none;background:#ef4444;color:#fff;border-radius:999px;min-width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;font-size:10.5px;font-weight:700;padding:0 5px;">
                {{ conv.unreadCount > 99 ? '99+' : conv.unreadCount }}
              </span>
            </div>
            <!-- The number, when we have one worth showing. A widget visitor who has not given
                 a number yet gets no line at all - better than a raw session UUID. -->
            <div *ngIf="convSubtitle(conv) as sub" style="font-size:11px;color:var(--text-color-secondary);">{{ sub }}</div>
            <!-- Manager/admin context: who owns this chat's case + where it sits (journey › phase › stage). -->
            <div *ngIf="isManagerView && (conv.ownerName || conv.journeyName || conv.phaseName || conv.stageName)"
                 style="display:flex;flex-wrap:wrap;gap:3px;margin-top:2px;align-items:center;">
              <span *ngIf="conv.ownerName" title="Lead owner"
                    style="font-size:9.5px;background:var(--surface-100);border:1px solid var(--surface-border);border-radius:999px;padding:1px 6px;"><i class="pi pi-user" style="font-size:8.5px;margin-right:3px;"></i>{{ conv.ownerName }}</span>
              <span *ngIf="conv.journeyName" title="Journey"
                    style="font-size:9.5px;background:var(--surface-100);border:1px solid var(--surface-border);border-radius:999px;padding:1px 6px;"><i class="pi pi-sitemap" style="font-size:8.5px;margin-right:3px;"></i>{{ conv.journeyName }}</span>
              <span *ngIf="conv.phaseName" title="Phase"
                    style="font-size:9.5px;background:var(--surface-100);border:1px solid var(--surface-border);border-radius:999px;padding:1px 6px;">{{ conv.phaseName }}</span>
              <span *ngIf="conv.stageName" title="Stage"
                    style="font-size:9.5px;background:var(--surface-100);border:1px solid var(--surface-border);border-radius:999px;padding:1px 6px;">{{ conv.stageName }}</span>
              <button *ngIf="conv.caseId" type="button" (click)="openCaseInNewTab(conv, $event)"
                      title="Open this case in a new tab"
                      style="border:none;background:transparent;color:var(--primary-color);cursor:pointer;padding:1px 4px;font-size:11px;flex:none;">
                <i class="pi pi-external-link"></i>
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="loadingMore" class="conv-sidebar__loadmore" style="text-align:center;padding:10px;color:var(--text-color-secondary);">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
      </div>
    </aside>

    <!-- Drag handle 1 -->
    <div class="col-divider" *ngIf="!hideSidebar" (mousedown)="startDrag($event, 'sidebar')">
      <span class="col-divider__grip"></span>
    </div>

    <!-- ── COL 2: Chat ──────────────────────────────────────────── -->
    <!-- The thread itself now lives in <app-chat-thread>, shared with the floating chat dock so a
         fix lands in both. This page keeps only the chrome: the list on the left, the workflow rail
         on the right. The component owns its own history, polling, 24h window and template picker. -->
    <!-- No wrapper: <app-chat-thread> renders its own <section class="conv-chat"> and its host
         is styled as the flex column that section needs. Wrapping it in another .conv-chat just
         nested two identical blocks. -->
    <app-chat-thread [conversation]="selected"
                     (handoffChanged)="onThreadHandoffChanged($event)"></app-chat-thread>



  </div><!-- /conv-body -->
</div><!-- /conv-page -->

<!-- ── Closed-window template picker ─────────────────────────────────────────── -->
